import fetch from "./fetch";
import fetchTypes from "./fetchTypes";
import fetchJobTypes from "./fetchJobTypes";
import createRoadSinister from "./createRoadSinister";
import updateRoadSinister from "./updateRoadSinister";
import fetchBinnacle from "./fetchBinnacle";
import fetchRejectedQuantifications from "./fetchRejectedQuantifications";
import createBinnacle from "./createBinnacle";
import fetchSinistersInWP from "./fetchSinistersInWP";
import rejectFiles from "./rejectFiles";

import fetchByStatus from "./fetchByStatus";
import extranetFetchByStatus from "./extranetFetchByStatus";
import quickSearch from "./quickSearch";

import bulkReviReassignation from "./bulkReviReassignation";
import affectedVisibleRepports from "./affectedVisibleRepports";
import changeYearReport from "./changeYearReport"
import changeDateTypeReport from "./changeDateTypeReport"
import checkFullDocumentation from "./checkFullDocumentation";

import fetchAdminChiefs from "./fetchAdminChiefs";
import updateAdvanceStatusCROL from "./updateAdvanceStatusCROL";
import changeStatusToCP from "./changeStatusToCP";
import changeSinisterTypeDUA from "./changeSinisterTypeDUA";

import authorizeQuantification from "./authorizeQuantification";

export default {
  fetch,
  fetchTypes,
  createRoadSinister,
  updateRoadSinister,
  fetchJobTypes,
  fetchBinnacle,
  fetchRejectedQuantifications,
  createBinnacle,
  rejectFiles,
  fetchByStatus,
  extranetFetchByStatus,
  fetchSinistersInWP,
  quickSearch,
  bulkReviReassignation,
  affectedVisibleRepports,
  changeYearReport,
  changeDateTypeReport,
  checkFullDocumentation,
  fetchAdminChiefs,
  updateAdvanceStatusCROL,
  changeStatusToCP,
  changeSinisterTypeDUA,
  authorizeQuantification
};



// WEBPACK FOOTER //
// ./src/services/sinister/index.js